import userauth from '~/helpers/userauth'

export default (to, from, next) => {
    if (userauth.isLoggedIn()) {
        next({name: 'dashboard'})
    } else {
        next()
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/guest.js